import React from "react";
import { Container } from "react-bootstrap";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import "./BestHealthDeals.css";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";
export default function BestHealthDeals({ banners }) {
  const navigate = useNavigate();

  return (
    <div
      className="BestHealthDeals-section"
      style={{
        backgroundImage: `url("${process.env.REACT_APP_IMG_URL}${banners?.image}")`,
        // backgroundImage: `url("/assets/images/section_banner/besthealthbg.png")`,
      }}
    >
      <div className="diagonal-panel" />
      <Container className="banner-container">
        <div className="wrapper-container">
          <span className="eyebrow-text">
            <i className="pulse-dot" /> Limited Time Offer
          </span>
          <h2 className="heading-text">Best Health Deals for You</h2>
          <p className="sub-text">{banners?.name || ""}</p>
          <Green_btn
            btnText="Grab Now  →"
            onClick={() => {
              if (banners?.category_id) {
                navigate(
                  `/categories?category_id=${encodeId(banners?.category_id)}`,
                );
              }
            }}
          />
        </div>
      </Container>
      <div className="deal-badge">
        <span className="deal-badge-top">Best</span>
        <span className="deal-badge-main">Deals</span>
        <span className="deal-badge-bottom">Every Day</span>
      </div>
    </div>
  );
}
